export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer" className="bg-background-50 border-t border-background-200/60">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <span className="text-lg font-heading text-primary-500 block mb-3">51电影网</span>
            <p className="text-xs text-foreground-500 leading-relaxed">
              专注整理擦边电影未删减版、限制级片段及隐藏敏感镜头资源。每周更新高清完整版在线观看合集，带你发现删减背后的秘密。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-800 mb-3">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">首页</a>
              <a href="#index" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">专题合集</a>
              <a href="#ranking" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">热度榜单</a>
              <a href="#carousel" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">焦点专题</a>
              <a href="#faq" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">常见问答</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-800 mb-3">热门话题</h4>
            <div className="flex flex-wrap gap-2">
              <span className="text-xs px-2 py-1 rounded-full bg-background-100 border border-background-200/60 text-foreground-500 whitespace-nowrap">未删减版</span>
              <span className="text-xs px-2 py-1 rounded-full bg-background-100 border border-background-200/60 text-foreground-500 whitespace-nowrap">限制级片段</span>
              <span className="text-xs px-2 py-1 rounded-full bg-background-100 border border-background-200/60 text-foreground-500 whitespace-nowrap">隐藏镜头</span>
              <span className="text-xs px-2 py-1 rounded-full bg-background-100 border border-background-200/60 text-foreground-500 whitespace-nowrap">导演剪辑版</span>
              <span className="text-xs px-2 py-1 rounded-full bg-background-100 border border-background-200/60 text-foreground-500 whitespace-nowrap">海外完整版</span>
              <span className="text-xs px-2 py-1 rounded-full bg-background-100 border border-background-200/60 text-foreground-500 whitespace-nowrap">高清修复</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-800 mb-3">合作伙伴</h4>
            <p className="text-xs text-foreground-400 leading-relaxed">
              合作伙伴信息持续更新中，敬请期待。
            </p>
            <div className="mt-4">
              <h4 className="text-sm font-medium text-foreground-800 mb-3">关于我们</h4>
              <a href="#about" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">了解51电影网</a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/60 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {currentYear} 51电影网 · 擦边电影未删减版限制级片段隐藏资源敏感镜头，全网独家高清完整版在线观看合集
          </p>
          <div className="flex items-center gap-4">
            <a href="#contact" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
            <a href="#faq" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">常见问答</a>
          </div>
        </div>
      </div>
    </footer>
  );
}